import type { ReactNode } from 'react'
import { ThemeProvider } from '@/theme'
import { LoadingProvider } from './LoadingProvider'
import AuthProvider from './AuthProvider'

interface AppProviderProps {
  children: ReactNode
}

export default function AppProvider({ children }: AppProviderProps) {
  return (
    <ThemeProvider>
      <AuthProvider>
        <LoadingProvider>
          {children}
        </LoadingProvider>
      </AuthProvider>
    </ThemeProvider>
  )
}
